import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import style from "../OrderInfoClient.module.scss";
import CloseIcon from "../../../shared/icons/CloseIcon";
import CommentIcon from "../../../shared/icons/CommentIcon";
import OrderInfoClientMoreMenu from "./OrderInfoClientMoreMenu";
import EyeIcon from "../../../shared/icons/EyeIcon";
import OrderViewsModal from "../../order-info/components/OrderViewsModal";
import AppTooltip from "../../../shared/AppTooltip/AppTooltip";
import { numberToFinanceFormat } from "../../../../utils";
import { CURRENCIES } from "../../../../mock";

const OrderInfoClientHeader = ({
  item,
  setIsOpen,
  onOpenChat,
  unreadCount = 0,
  onForceUpdate,
  orderViews = [],
  hasBids = false,
  onOrderDataChanged,
  onEditOrder,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const [isViewersModalOpen, setIsViewersModalOpen] = useState(false);
  const routeTitle = item ? `${item.cityFromName || ""} - ${item.cityToName || ""}` : "";
  const subtitleMain = item
    ? `№ ${item.number}${item.referenceNumber ? ` - ${item.referenceNumber}` : ""}`
    : "";
  const currencySymbol = CURRENCIES[item?.currency || "KZT"]?.symbol || "";

  const totalQuantity = orderViews.reduce((sum, view) => sum + (view.quantity || 0), 0);
  const isOwner = user?.companyId === item?.companyId;

  return (
    <div className={style.header}>
      <div className={style.header_left}>
        <CloseIcon
          fill="#6D7885"
          width="24"
          height="24"
          onClick={() => setIsOpen && setIsOpen(false)}
          style={{ cursor: "pointer", flexShrink: 0 }}
        />
        <div className={style.header_info}>
          <div className={style.header_title}>{routeTitle}</div>
          <div className={style.header_subtitle}>
            <span className={style.header_subtitle_main}>{subtitleMain}</span>
            {item?.expeditorName ? (
              <>
                <span
                  className={style.header_subtitle_main}
                  data-tooltip-id="client-header-expeditor-tooltip"
                >
                  {`• ${t("orderInfoExpeditor.header.partner")}:`}
                </span>
                <span
                  className={style.header_subtitle_expeditor}
                  data-tooltip-id="client-header-expeditor-tooltip"
                >
                  {item.expeditorName}
                </span>
                <AppTooltip
                  id="client-header-expeditor-tooltip"
                  positionStrategy="fixed"
                  delayShow={50}
                >
                  {item.expeditorName}
                </AppTooltip>
              </>
            ) : null}
          </div>
        </div>
        {item?.price ? (
          <div className={style.header_price}>
            {currencySymbol}
            {numberToFinanceFormat(item.price, true)}
          </div>
        ) : null}
      </div>
      <div className={style.header_right}>
        {isOwner && (
          <div className={style.views} onClick={() => setIsViewersModalOpen(true)}>
            <EyeIcon />
            <div className={style.views_count}>{totalQuantity}</div>
          </div>
        )}
        <div className={style.header_chat_wrapper}>
          <button className={style.header_chat_btn} onClick={onOpenChat}>
            <CommentIcon width={20} height={20} fill="#0D3B66" type={2} />
            <span>{t("orderInfoExpeditor.header.chat")}</span>
          </button>
          {unreadCount > 0 && <div className={style.header_chat_badge}>{unreadCount}</div>}
        </div>
        <OrderInfoClientMoreMenu
          item={item}
          onForceUpdate={onForceUpdate}
          setIsOpen={setIsOpen}
          hasBids={hasBids}
          onOrderDataChanged={onOrderDataChanged}
          onEditOrder={onEditOrder}
        />
      </div>

      <OrderViewsModal
        isOpen={isViewersModalOpen}
        onClose={() => setIsViewersModalOpen(false)}
        orderViews={orderViews}
      />
    </div>
  );
};

export default OrderInfoClientHeader;
